import Http from '@/api/http.js'

export default {

  index(filter) {
    return Http.get('/regions', {params: {...filter}})
  },

  treeChildren(params = {}) {
    return Http.get('/regions/tree_children', { params })
  },

  create(region){
    return Http.post(`/regions`, {region: {...region}})
  },
  create_bulk(regions){
    return Http.post(`/regions`, { bulk_regions: [...regions] })
  },

  update(region){
    return Http.put(`/regions/${region.id}`, {region: {...region}})
  },

  show(id) {
    return Http.get(`/regions/${id}`);
  }, 

  delete(id){
    return Http.delete(`/regions/${id}`)
  }

}
